<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">流量计阈值开/停设置</div>
    </div>
    <el-table
      :data="dataList"
      border
      lazy
      v-loading="dataListLoading"
      height="calc(100vh - 110px)"
      style="width: 100%"
      ref="scrollTable"
    >
      <el-table-column
        prop="flowMeterName"
        header-align="center"
        align="center"
        label="流量计名称"
      />
      <el-table-column
        header-align="center"
        align="center"
        width="140"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.is_open_alarm === 1"
            @click="stopHandle(scope.row)"
            type="danger"
          >禁用报警</el-button>
          <el-button
            v-else
            @click="openHandle(scope.row)"
            type="success"
          >启用报警</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      popstateLock: 0, //是否监听物理返回键
      dataForm: {
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      pageCount: 5,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      stationOptions: [],
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  created() {
    this.getDataList();
  },
  mounted () {
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
    // this.scrollLoad();
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 获取选中的地址信息
    getStation(val) {
      this.stationOptions.forEach(item => {
        if (item.id === val) {
          this.dataForm.area = item.flowMeterName
        }
      })
    },
    // 后面获取数据列表
    async getDataList() {
      this.dataListLoading = true;
      // 根据获取的数据请求符合条件的工单
      await this.$http.httpGet('/app/tbEquipment/combo', {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.dataList = res.list;
          this.dataListLoading = false;
        } else {
          this.$message.error('获取数据失败: ' + res.msg);
          this.dataList = [];
          this.dataListLoading = false;
        }
      }).catch(() => {
        this.dataListLoading = false;
      })
    },
    // 禁用按钮触发
    async stopHandle(row) {
      this.$confirm(`是否执行${row.flowMeterName}禁用报警设置?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.httpPost(`/app/tbEquipment/disabled/${row.id}`, {}).then(res => {
          if (res.code === 0 && res.msg === 'success') {
            this.$message({
              type: 'success',
              message: '禁用报警成功',
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
          } else {
            this.$message.error({
              type: 'info',
              message: res.msg,
              duration: 1500
            });
          }
        })
      }).catch(() => {
      });
    },
    // 启用按钮触发
    openHandle(row) {
      this.$confirm(`是否执行${row.flowMeterName}启用报警设置?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.httpPost(`/app/tbEquipment/enable/${row.id}`, {}).then(res => {
          if (res.code === 0 && res.msg === 'success') {
            this.$message({
              type: 'success',
              message: '启用报警成功',
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
          } else {
            this.$message.error({
              message: res.msg,
              duration: 1500
            });
          }
        })
      }).catch(() => {
      });
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }
  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }
}
</style>
